import { AuthState } from './types';

export const state = (): AuthState => initialState();

export const initialState = (): AuthState => ({
  account: null,
  azureData: undefined,
  environment: '',
  isUserInAzureAdminGroup: undefined,
  userAdminGroups: [],
  accountId: undefined,
  error: false,
  isLoadSupportContactList: false,
  isInitialRedirect: !!localStorage.getItem('initialBrowserPath'),
});
